<script>
import STable from '@/components/Table/'
import { exportDataToExcel, loadPermissionList, loadTestDataList } from '@/api/data'
import ShowBigImage from '@/views/data/modal/ShowBigImage.vue'
import moment from 'moment'
import * as JsStore from 'jsstore'
import workerInjector from 'jsstore/dist/worker_injector'
import Vue from 'vue'
import VideoPreview from '@/views/data/modal/VideoPreview.vue'

export default {
  name: 'TestRecord',
  components: {
    STable
  },
  data () {
    return {
      inited: false,
      locale: {
        emptyText: this.$t('table.emptyText')
      },
      scrollHeight: document.body.clientHeight - 306,
      col: {
        md: 10,
        lg: 8,
        xl: 6,
        xxl: 4
      },
      qTime: [],
      // 查询参数
      queryParam: {
        name: '',
        time: []
      },
      // 表头
      columns: [
        {
          title: this.$t('user.test.id'),
          dataIndex: '_id',
          align: 'center',
          width: 130,
          scopedSlots: { customRender: '_id' }
        },
        {
          title: this.$t('user.test.user'),
          dataIndex: 'name',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('user.org.name'),
          dataIndex: 'org_name',
          align: 'center',
          width: 180
        },
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
          width: 130,
          scopedSlots: { customRender: 'id' }
        },
        {
          title: this.$t('user.test.date'),
          dataIndex: 'create_date',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'create_date' }
        },
        {
          title: this.$t('user.test.time'),
          dataIndex: 'create_time',
          align: 'center',
          width: 110,
          scopedSlots: { customRender: 'create_time' }
        },
        {
          title: this.$t('user.test.value'),
          dataIndex: 'measure_value',
          align: 'center',
          width: 130,
          scopedSlots: { customRender: 'measure_value' }
        },
        {
          title: this.$t('user.test.appraise'),
          dataIndex: 'appraise',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'appraise' }
        },
        {
          title: this.$t('user.test.image'),
          dataIndex: 'image',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'image' }
        },
        {
          title: this.$t('user.test.video'),
          dataIndex: 'video',
          align: 'center',
          width: 110,
          scopedSlots: { customRender: 'video' }
        },
        {
          title: this.$t('user.test.location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'location' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: async (parameter) => {
        this.newDataNum = 0
        const mId = Vue.ls.get('USRRID')
        this.newDataTag = false
        const where = {
          m_id: mId
        }
        if (this.queryParam._id && this.queryParam._id.length > 0) {
          where._id = parseInt(this.queryParam._id)
        }
        if (this.queryParam.name && this.queryParam.name.length > 0) {
          where.name = {
            like: `%${this.queryParam.name}%`
          }
        }
        if (this.qTime.length > 0) {
          where.create_time = {
            '>=': this.qTime[0].startOf('day').toDate(),
            '<=': this.qTime[1].endOf('day').toDate()
          }
        }
        const totalCount = await this.connection.count({
          from: 'test_record',
          where: Object.keys(where).length > 0 ? where : null
        })
        const dataArr = await this.connection.select({
          from: 'test_record',
          where: Object.keys(where).length > 0 ? where : null,
          order: {
            by: 'create_time',
            type: 'desc'
          },
          limit: parameter.pageSize,
          skip: (parameter.pageNo - 1) * parameter.pageSize
        })
        if (dataArr.length > 0) {
          if (this.lastId) {
            if (dataArr[0]._id > this.lastId) {
              this.lastId = dataArr[0]._id
            }
          } else {
            this.lastId = dataArr[0]._id
          }
        }
        for (const item of dataArr) {
          if (!this.inited) {
            item.disabled = true
          }
          item.create_time = moment(item.create_time).format('YYYY-MM-DD HH:mm:ss')
          item.disabled = this.userLevelMap ? this.userLevelMap[item.user_id] === 0 : true
          item.org_name = this.orgNameMap ? (this.orgNameMap[item.user_id] || '') : ''
        }
        return {
          data: dataArr,
          pageSize: parseInt(parameter.pageSize),
          pageNo: parseInt(parameter.pageNo),
          totalPage: Math.ceil(totalCount / parseInt(parameter.pageSize)),
          totalCount: totalCount
        }
      },
      connection: null,
      lastId: null,
      dataLoadTimer: null,
      newDataTag: false,
      users: null,
      selectedRowKeys: [],
      selectedRows: [],
      userInfoMap: null,
      userLevelMap: null,
      orgNameMap: {},
      imageBase64Map: {}
    }
  },
  created () {
    const _this = this
    this.initData()
    this.$on('logout', () => {
      console.log('logout')
    })
    window.imageLoaded = function (target) {
      (function (t) {
        var canvas = document.createElement('canvas') // 创建canvas DOM元素
        var ctx = canvas.getContext('2d')
        var img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = t.src
        img.onload = function () {
          canvas.height = t.height // 指定画板的高度,自定义
          canvas.width = t.width // 指定画板的宽度，自定义
          ctx.drawImage(img, 0, 0, t.width, t.height) // 参数可自定义
          var dataURL = canvas.toDataURL('image/jpeg')
          _this.imageBase64Map[t.dataset.id] = {
            width: t.width,
            height: t.height,
            dataURL: dataURL
          }
        }
      })(target)
    }
  },
  beforeUnmount () {
    if (this.dataLoadTimer) {
      clearTimeout(this.dataLoadTimer)
      this.dataLoadTimer = null
    }
    if (this.connection) {
      this.connection.terminate()
    }
    window.imageLoaded = null
  },
  methods: {
    async initData () {
      const _this = this
      const mId = Vue.ls.get('USRRID')
      let hide = null
      const key = 'downloading'
      if (!this.inited) {
        hide = this.$message.loading({ content: this.$t('user.record.data.syncing') + '0%。', key, duration: 0 })
      }
      var connection = null
      // https://jsstore.net/
      if (!this.connection) {
        connection = new JsStore.Connection()
        connection.addPlugin(workerInjector)
        this.connection = connection
      } else {
        connection = this.connection
      }

      await connection.initDb({
        name: 'record',
        tables: [{
          name: 'test_record',
          columns: {
            _id: { primaryKey: true },
            id: { dataType: 'string' },
            m_id: { notNull: false, dataType: 'number' },
            user_id: { notNull: true, dataType: 'number' },
            name: { dataType: 'string' },
            device_name: { notNull: false, dataType: 'string' },
            mac: { notNull: false, dataType: 'string' },
            measure_value: { notNull: true, dataType: 'number' },
            image_path: { dataType: 'string' },
            location: { dataType: 'object' },
            create_time: { notNull: true, dataType: 'date_time' },
            video: { dataType: 'string' }
          },
          alter: {
            // for version 2
            2: {
              modify: {
                device_name: {
                  notNull: false
                }
              }
            },
            3: {
              modify: {
                mac: {
                  notNull: false
                }
              }
            },
            4: {
              add: {
                video: {
                  notNull: false,
                  dataType: 'string'
                }
              }
            },
            5: {
              add: {
                m_id: {
                  notNull: false,
                  dataType: 'number'
                }
              }
            }
          }
        }],
        version: 5
      })
      await this.sleep(1000)
      const idNewUser = Vue.ls.get('NEWU')
      if (idNewUser) {
        await connection.clear('test_record')
        Vue.ls.remove('NEWU')
      }
      const pres = await loadPermissionList({
        type: 'all',
        pageNo: 1,
        pageSize: 1000
      })
      const users = pres.result.data
      this.users = users
      const userInfoMap = {}
      const userLevelMap = {}
      const orgNameMap = {}
      let index = 0
      for (const user of users) {
        userLevelMap[user.user_id] = user.user_level
        index++

        userInfoMap[user.user_id] = user.user
        orgNameMap[user.user_id] = user.org_name

        if (user.delete_tag === 1 || user.status === 0) {
          await connection.remove({
            from: 'test_record',
            where: {
              user_id: user.user_id
            }
          })
          this.refreshTable()
        } else {
          if (user.user_level === 0) {
            await connection.remove({
              from: 'test_record',
              where: {
                user_id: user.user_id,
                create_time: {
                  '<': moment().subtract(2, 'days').toDate()
                }
              }
            })
          }

          const recordResp = await loadTestDataList({
            pageSize: this.inited ? 10 : 200,
            pageNo: 1,
            user_id: user.user_id
          })
          const records = recordResp.result.data
          const values = []
          for (const record of records) {
            if ((!this.newDataTag) && (this.lastId) && record.record_id > this.lastId) {
              this.newDataTag = true
            }
            values.push({
              _id: record.record_id,
              user_id: user.user_id,
              is_pro: !!((userLevelMap[user.user_id] && userLevelMap[user.user_id] === 2)),
              m_id: mId,
              id: record.id,
              name: record.name,
              device_name: record.device_name,
              mac: record.mac,
              measure_value: record.measure_value,
              image_path: record.image_path,
              location: record.location,
              video: record.video,
              create_time: new Date(record.create_time_stamp)
            })
          }

          await connection.insert({
            into: 'test_record',
            upsert: true,
            values: values
          })
        }

        if (!this.inited) {
          hide = this.$message.loading({
            content: this.$t('user.record.data.syncing') + `${(index * 100 / users.length).toFixed(2)}%。`,
            key,
            duration: 0
          })
        }
      }
      if (!this.inited) {
        hide = this.$message.success({
          content: this.$t('user.record.data.sync.finish'),
          key
        })
        setTimeout(hide, 2000)
        this.userInfoMap = userInfoMap
        this.orgNameMap = orgNameMap

        this.inited = true
        this.refreshTable()
      }
      this.userLevelMap = userLevelMap
      this.dataLoadTimer = setTimeout(function () {
        _this.initData()
      }, 5000)
    },
    disabledDate (current) {
      // Can not select days before today and today
      // return current && (current > moment().endOf('day') || (current < moment().subtract(2, 'days').startOf('day')))
      return current && (current > moment().endOf('day'))
    },
    formatValue: (value, disabled) => {
      if (disabled) {
        return '--'
      }
      let v = (value * 5).toFixed(2)
      if (value < 0.015) {
        v = '0.00'
      }
      return v
    },
    refreshTable () {
      if (this.qTime.length > 0) {
        this.queryParam.time = this.qTime[0].format('YYYY-MM-DD 00:00:00') + ',' + this.qTime[1].format('YYYY-MM-DD 23:59:59')
      }
      this.$refs.table.refresh()
    },
    showImage (url) {
      this.showModal(ShowBigImage, this.$t('user.test.image'), 380, 460, { url: url })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    getCheckboxProps (record) {
      return {
        props: {
          disabled: record.disabled
        }
      }
    },
    sleep (t) {
      return new Promise(resolve => setTimeout(resolve, t))
    },
    playVideo (video) {
      this.showModal(VideoPreview, this.$t('user.test.video'), 380, 480, { name: video })
    },
    async exportData () {
      const hide = this.$message.loading(this.$t('user.excel.exporting'), 0)
      const randomId = ('0000000' + Math.floor(Math.random() * 100000)).slice(-7)
      var date = moment().format('YYYY-MM-DD')
      var tmpFileName = `Alcohol_Check_${randomId}_${date}.xlsx`
      const data = []
      for (let i = 0; i < this.selectedRows.length; i++) {
        const item = this.selectedRows[i]
        const obj = {}
        const colorMap = {
          white_green: '白地に緑文字',
          green_white: '緑地に白文字',
          yellow_black: '黄色地に黒文字',
          black_yellow: '黒地に黄色文字',
          blue_green: '青地に緑文字',
          white_red: '白地に赤い斜線'
        }
        if (this.userInfoMap[item.user_id] && this.userInfoMap[item.user_id].color && this.userInfoMap[item.user_id].color.length > 0) {
          obj.color = colorMap[this.userInfoMap[item.user_id].color]
        } else {
          obj.color = '-'
        }
        obj.id = this.userInfoMap[item.user_id] ? (this.userInfoMap[item.user_id].uId || item.id) : item.id
        obj.name = this.userInfoMap[item.user_id] ? (this.userInfoMap[item.user_id].name || item.name) : item.name
        obj.area = this.userInfoMap[item.user_id] ? (this.userInfoMap[item.user_id].area || '-') : '-'
        obj.plateName = this.userInfoMap[item.user_id] ? (this.userInfoMap[item.user_id].plateName || '-') : '-'
        obj.number = this.userInfoMap[item.user_id] ? (this.userInfoMap[item.user_id].number || '-') : '-'
        obj.type = this.userInfoMap[item.user_id] ? (this.userInfoMap[item.user_id].type || '-') : '-'
        obj.image = this.imageBase64Map[item._id]
        obj.date = item.create_time.slice(0, 10)
        obj.time = item.create_time.slice(11)
        obj.value = this.formatValue(item.measure_value)
        obj.appraise = item.measure_value > 0.03 ? this.$t('user.excel.appraise.no') : this.$t('user.excel.appraise.yes')
        data.push(obj)
      }
      const resp = await exportDataToExcel({
        fileName: `alc_test_data.xlsx`,
        sheets: [{
          title: 'test_record',
          columns: [{
            title: this.$t('user.id'),
            dataIndex: 'id',
            width: 11
          },
            {
              title: this.$t('user.name'),
              dataIndex: 'name',
              width: 22
            },
            {
              title: this.$t('user.car.area'),
              dataIndex: 'area',
              width: 10
            },
            {
              title: this.$t('user.car.type'),
              dataIndex: 'type',
              width: 12
            },
            {
              title: this.$t('user.car.plateName'),
              dataIndex: 'plateName',
              width: 10
            },
            {
              title: this.$t('user.car.number'),
              dataIndex: 'number',
              width: 15
            },
            {
              title: this.$t('user.car.color'),
              dataIndex: 'color',
              width: 19
            },
            {
              title: this.$t('user.test.date'),
              dataIndex: 'date',
              width: 15
            },
            {
              title: this.$t('user.test.time'),
              dataIndex: 'time',
              width: 13
            },
            {
              title: this.$t('user.test.value'),
              dataIndex: 'value',
              width: 18
            },
            {
              title: this.$t('user.test.appraise'),
              dataIndex: 'appraise',
              width: 18
            },
            {
              title: this.$t('user.test.image'),
              dataIndex: 'image',
              type: 'image',
              width: 24
            }],
          data: data
        }]
      })
      this.saveResultAsExcel(resp, tmpFileName)
      hide()
    },
    showLocation (location, isPro) {
      if (!isPro) {
        this.$message.error(this.$t('user.test.location.not.pro'))
        return
      }
      window.open('https://www.google.com/maps/place/' + location.location, '_blank')
    }
  }
}
</script>

<template>
  <div class="test-record-page">
    <div class="filter-card">
      <div class="filter-card__header">
        <span class="filter-card__title">{{ $t('user.action.search') }}</span>
      </div>
      <div class="filter-card__body">
        <a-row :gutter="16">
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('user.test.id') }}</label>
              <a-input class="filter-item__input" v-model="queryParam._id" allowClear :placeholder="$t('user.test.id')" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('user.test.user') }}</label>
              <a-input class="filter-item__input" v-model="queryParam.name" allowClear :placeholder="$t('user.test.user')" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('user.test.date') }}</label>
              <a-range-picker
                class="filter-item__input"
                v-model="qTime"
                allowClear
                :disabled-date="disabledDate" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item filter-item--actions">
              <a-button icon="search" @click="refreshTable" type="primary">{{ $t('user.action.search') }}</a-button>
              <a-button icon="export" :disabled="selectedRowKeys.length === 0" @click="exportData">
                {{ $t('user.action.download') }}
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="table-card">
      <transition name="slide-down">
        <a-alert
          v-if="newDataTag"
          class="table-card__alert"
          type="info"
          show-icon
          :message="$t('user.test.data.new.tip')" />
      </transition>
      <s-table
        :columns="columns"
        :data="loadData"
        ref="table"
        bordered
        :locale="locale"
        size="small"
        :showPagination="true"
        :rowKey="(record) => record._id"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }"
        :scroll="{ x: 1420, y: scrollHeight }">
        <span slot="_id" slot-scope="text, record" class="cell-id">{{ ('000000000000' + record._id).slice(-12) }}</span>
        <span slot="id" slot-scope="text, record" class="cell-muted">{{ record.id || '--' }}</span>
        <span slot="license_plate_number" slot-scope="text, record">{{ record.license_plate_number || '--' }}</span>
        <span slot="create_date" slot-scope="text, record">{{ record.create_time.slice(0, 10) }}</span>
        <span slot="create_time" slot-scope="text, record" class="cell-time">{{ record.create_time.slice(11) }}</span>
        <span
          slot="measure_value"
          slot-scope="text, record"
          class="cell-value"
          :class="{ 'cell-value--disabled': record.disabled }"
          :title="record.disabled ? $t('user.test.value.limited') : ''">
          {{ formatValue(record.measure_value, record.disabled) }}
        </span>
        <span slot="appraise" slot-scope="text, record">
          <span v-if="record.measure_value < 0.015" class="appraise-badge appraise-badge--pass">
            <span class="appraise-badge__dot"></span>{{ $t('user.test.appraise.yes') }}
          </span>
          <span v-else-if="record.measure_value < 0.03" class="appraise-badge appraise-badge--warn">
            <span class="appraise-badge__dot"></span>{{ $t('user.test.appraise.warn') }}
          </span>
          <span v-else class="appraise-badge appraise-badge--fail">
            <span class="appraise-badge__dot"></span>{{ $t('user.test.appraise.no') }}
          </span>
        </span>
        <div slot="image" slot-scope="text, record" class="cell-image">
          <div v-if="record.image_path" class="cell-image__wrapper">
            <img
              :data-id="record._id"
              :src="record.image_path"
              onload="imageLoaded(this)"
              @click="showImage(record.image_path)"
              class="cell-image__thumb" />
          </div>
          <span v-else class="cell-muted">--</span>
        </div>
        <div slot="video" slot-scope="text, record" class="cell-video">
          <span
            v-if="record.video"
            class="cell-video__btn"
            :title="$t('user.test.video.play')"
            @click="playVideo(record.video)">
            <i class="iconfont icon-bofang"></i>
          </span>
          <span v-else class="cell-muted">--</span>
        </div>
        <div slot="location" slot-scope="text, record" class="cell-location">
          <a
            v-if="record.location && record.location.location && record.location.location.split(',')[0].split('.')[1].length >= 4"
            class="cell-location__link"
            @click="showLocation(record.location, record.is_pro)">
            <a-icon type="environment" class="cell-location__icon" />
            {{ record.location.city_name }}
          </a>
          <span v-else class="cell-muted">--</span>
        </div>
      </s-table>
    </div>
  </div>
</template>

<style scoped lang="less">
@primary: #52C41A;
@border-color: #e8e8e8;
@text-primary: rgba(0, 0, 0, 0.85);
@text-secondary: rgba(0, 0, 0, 0.45);
@bg-page: #f0f2f5;
@bg-card: #fff;
@radius: 6px;
@shadow-card: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
@shadow-card-hover: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06);
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

.test-record-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Filter card ── */
.filter-card {
  background: @bg-card;
  border-radius: @radius;
  box-shadow: @shadow-card;
  overflow: hidden;

  &__header {
    padding: 12px 20px 0;
    display: flex;
    align-items: center;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: @text-primary;
    letter-spacing: 0.01em;
  }

  &__body {
    padding: 12px 20px 16px;
  }
}

.filter-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  &__label {
    flex-shrink: 0;
    width: 56px;
    font-size: 13px;
    color: @text-secondary;
    text-align: right;
    margin-right: 10px;
    white-space: nowrap;
  }

  &__input {
    flex: 1;
    min-width: 0;
  }

  &--actions {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-top: 2px;

    .ant-btn {
      min-width: 80px;
    }
  }
}

/* ── Table card ── */
.table-card {
  background: @bg-card;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;

  &__alert {
    margin-bottom: 12px;
    border-radius: @radius;
    border: none;
    background: #e6f7ff;
  }
}

/* ── Cell styles ── */
.cell-id {
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
  color: @text-secondary;
  letter-spacing: 0.02em;
}

.cell-muted {
  color: @text-secondary;
  font-size: 13px;
}

.cell-time {
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
  color: @text-secondary;
}

.cell-value {
  font-weight: 600;
  font-size: 14px;
  color: @text-primary;

  &--disabled {
    color: @text-secondary;
    font-weight: 400;
  }
}

/* ── Appraise badges ── */
.appraise-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6;
  white-space: nowrap;

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &--pass {
    background: #f6ffed;
    color: #389e0d;

    .appraise-badge__dot {
      background: @primary;
    }
  }

  &--warn {
    background: #fff7e6;
    color: #d48806;

    .appraise-badge__dot {
      background: #faad14;
    }
  }

  &--fail {
    background: #fff1f0;
    color: #cf1322;

    .appraise-badge__dot {
      background: #ff4d4f;
    }
  }
}

/* ── Image cell ── */
.cell-image {
  display: flex;
  align-items: center;
  justify-content: center;

  &__wrapper {
    position: relative;
    display: inline-block;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid @border-color;
    transition: box-shadow @transition, transform @transition;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
      transform: scale(1.04);
    }
  }

  &__thumb {
    display: block;
    max-height: 72px;
    max-width: 120px;
    object-fit: cover;
  }
}

/* ── Video cell ── */
.cell-video {
  display: flex;
  align-items: center;
  justify-content: center;

  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(82, 196, 26, 0.08);
    cursor: pointer;
    transition: background @transition, transform @transition;

    .iconfont {
      font-size: 1.5rem;
      color: @primary;
      transition: color @transition;
    }

    &:hover {
      background: rgba(82, 196, 26, 0.15);
      transform: scale(1.08);

      .iconfont {
        color: darken(@primary, 8%);
      }
    }

    &:active {
      transform: scale(0.96);
    }
  }
}

/* ── Location cell ── */
.cell-location {
  &__link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: @primary;
    font-size: 13px;
    transition: color @transition;

    &:hover {
      color: darken(@primary, 10%);
    }
  }

  &__icon {
    font-size: 13px;
  }
}

/* ── Alert slide-down transition ── */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.25s ease-out;
  max-height: 60px;
  overflow: hidden;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .filter-card__body {
    padding: 12px 12px 16px;
  }

  .filter-item {
    margin-bottom: 8px;

    &__label {
      width: 48px;
      font-size: 12px;
    }
  }

  .table-card {
    padding: 12px;
  }
}
</style>
